import * as scroll from './scroll';
import * as parallax from './parallax';
import * as appear from './appear';
import * as stack from './stack';
// import * as transition from './transition';
import * as cursor from './cursor';

export const init = (): void => {
    scroll.init();
    parallax.init();
    appear.init();
    stack.init();
    // transition.init();
    cursor.init();
};
